import { FunctionComponent } from 'react';
import { UserDetailsInfo } from 'widgets/admin/UserDetails/ui';

export const UserDetailsInfoPage: FunctionComponent = () => {
	return <UserDetailsInfo />;
};
